<template>

<!-- <q-list dense separator v-if="item.date_status1 || item.date_status2 || $_.size(item.date_status3) || item.date_status4">

    <q-item-label header>Évènements</q-item-label>

    <q-item v-for="(el, key) in events" :key="key"
            v-show="! $_.isNull(item[el.column]) && $_.size(el.value)">

        <q-item-section avatar class="normal">
            <q-item-label caption><b v-html="el.label"></b></q-item-label>
        </q-item-section>

        <q-item-section v-if=" ! $_.isArray(el.value) && el.column != 'date_status3'"
                        :class="(el.column == 'date_status2' ? ' bg-'+courseStore().getStatusColor(el.status) : '')">

            <q-item-label caption :class="'q-ml-sm '+(el.column != 'date_status2' ? 'text-'+courseStore().getStatusColor(el.status) : '')">

                <b>{{ ((el.column == 'date_status1' && events[3]?.value)
                                    ? 'au'/*pour pas mettre 'depiuis le'.. */
                                    : el.caption)
                        +' '+ formatDate({datetime: item[el.column], withHour: true}) }}
                </b>
            </q-item-label>
        </q-item-section>

        !-- for date_status3 ... --
        <q-item-section v-else>
            !-- <q-item-label v-for="(v, k) in el.value" :key="k" --
            <q-item-label v-for="(v, k) in item.date_status3" :key="k"
                    caption :class="'q-ml-sm text-'+courseStore().getStatusColor(el.status)">

                <b>{{ el.caption }} {{ formatDate({datetime: v, withHour: true})  }}</b>
            </q-item-label>
        </q-item-section>
    </q-item>
</q-list> -->

<!-- {{log('in ListEvents.vue', item)}} -->

<q-list dense separator v-if="$_.size(item.status_all)" class="q-pb-md">

    <q-item-label header>Évènements Chronologiques</q-item-label>

    <q-item v-for="(status, pos) in item.status_all" :key="pos"
            v-show="status.skey != 'empty-line'">

        <q-item-section avatar class="q-mr--lg">
            <q-icon :name="status.icon" :color="status.color" />
        </q-item-section>

        <q-item-section>
            <q-item-label caption :class="'text-'+status.color">
                <b v-html="status.str"></b>
            </q-item-label>
        </q-item-section>
    
        <q-item-section side>
            <!-- <q-item-label caption v-if="!$_.isArray(status.date)" :key="k">
                <Popup v-if="status.comment" icon="info" padding="none" dense>{{ status.comment }}</Popup>
                {{ formatDate({datetime: status.date, withHour: true}) }}
            </q-item-label>
            <q-item-label caption v-else v-for="(date, k) in status.date" :key="k">
                <Popup v-if="$_.isArray(status.comment) && status.comment[k]" icon="info" padding="none" dense>{{ status.comment[k] }}</Popup>
                {{ formatDate({datetime: date, withHour: true}) }}
            </q-item-label> -->

            <!-- <StatusDates :status="item.status_all[status.pos]" -->
            <StatusDates :status="item.status_all[status.skey]"
                        dense /><!-- item-label  -->
        </q-item-section>

    </q-item>
</q-list>

</template>

<script setup>
import { formatDate } from "@helpers";
// import { courseStore } from '@stores'
import { ref/* , computed  */} from "@vue/reactivity";

import StatusDates from './StatusDates.vue'

const props = defineProps({
    item: Object,
})


// // let colis_state = courseStore().$state

// // log('in ListEvents.vue', props.item)

// // let date_status3 = computed(()=> props.item.date_status3)
// // let date_status3 = ref(props.item.date_status3)

// let events = [
//     {label: courseStore().getStatusLabel(1), status: 1, column: 'date_status1', caption: 'depuis le',  value: props.item.date_status1 /* value: 'depuis le '+formatDate({datetime: props.item.date_status1, withHour: true}) */ },
//     {label: courseStore().getStatusLabel(3), status: 3, column: 'date_status3', caption: 'le ',        value: props.item.date_status3/* fait direct dans le template sinon, ça réactive pas..!    props.item.date_status3 */ },
//     {label: courseStore().getStatusLabel(4), status: 4, column: 'date_status4', caption: 'au',         value: props.item.date_status4 /* 'au '+formatDate({datetime: props.item.date_status4, withHour: true}) */  },
//     {label: courseStore().getStatusLabel(2), status: 2, column: 'date_status2', caption: 'le',         value: props.item.date_status2 /* 'le '+formatDate({datetime: props.item.date_status2, withHour: true}) */  },
// ]

</script>
